import { TripProviderContact } from '../../lib/types/models/trip-provider/trip-provider-contact'
import { TripProviderContactInput } from '../../lib/types/models/trip-provider/trip-provider-contact-input'
import { UpdateInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function updateTripProviderContact(
  data: UpdateInput<TripProviderContactInput> & { tripProviderId: number }
) {
  const { id, tripProviderId, ...rest } = data
  return restApiClient
    .url(
      constructApiUrl(API.tripProviders.updateContact.url, { id: tripProviderId, contactId: id })
    )
    .patch<TripProviderContact, Partial<TripProviderContactInput>>(rest)
}
